import './scss/base.scss';

import Table        from './components/Table/Table.vue';

import Button       from './components/Button/Button.vue';
import Debug        from './components/Debug/Debug.vue';
import Dialog       from './components/Dialog/Dialog.vue';
import Form         from './components/Form/Form.vue';
import Label        from './components/Form/Label/Label.vue';
import Select       from './components/Form/Select/Select.vue';
import Treeselect   from './components/Form/Treeselect/Treeselect.vue';
import Range        from './components/Form/Range/Range.vue';
import Toggle       from './components/Form/Toggle/Toggle.vue';
import File         from './components/Form/File/File.vue';

import Grid         from './components/Grid/Grid.vue';
import Loader       from './components/Loader/Loader.vue';
import Tag          from './components/Tag/Tag.vue';
import Widget       from './components/Widget/Widget.vue';

import { Tabs, Tab } from './components/Tab';

import { DatePicker, Calendar, CalendarRanges, CalendarTime } from './components/Datepicker';

export default
{
    Debug,
    Table,
    Button,
    Calendar,
    CalendarRanges,
    CalendarTime,
    DatePicker,
    Dialog,
    Form,
    Label,
    Select,
    Treeselect,
    Range,
    Toggle,
    File,
    Grid,
    Loader,
    Tag,
    Widget,
    Tabs,
    Tab
}